<template>
  <el-dialog
    class="dialog"
    title="资源配置"
    width="1100px"
    :visible.sync="showPCCourseManage.flag"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    distroy-on-close
  >
    <div class="main-contant">
      <!-- 生效时间 --> 
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules">
        <el-form-item label="生效时间：" class="m-l-14" prop="expireDate">
          <el-date-picker
            class="date-picker"
            value-format="yyyy-MM-dd"
            size="small"
            v-model="ruleForm.expireDate"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="onDateChange"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <Search class="search_right" activeTab="1" :displayTypeList="displayTypeList" ref="search" @search="searchHandle" />
      <CommonTable ref="pageListTable" v-if="isLoad" :info="tableInfo" @HandleSelectionChanges="handleSelectionChanges" @SizeChange="sizeChange" @PageChange="pageChange"/>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel" size="small">取消</el-button>
      <el-button type="primary" size="small" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Search from "../newCourse/search.vue";
import { haveResource, getResources, saveLeaderHomeConfig } from "@/api/video";
import { getSysParamByTypes } from "@/api/sysParam";
import CommonTable from './table.vue'
import moment from "moment";
import { dateStringByFutureday } from '@/utils/timeFormat';

export default {
  components: {
    Search,
    CommonTable
  },
  props: {
    showPCCourseManage: {
      type: Object,
      default: () => {
        return {
          flag: false,
        };
      },
    },
  },
  data() {
    return {
      tableInfo: {},
      displayTypeList: [],
      ruleForm: {
        expireDate: [],
      },
      rules: {
        expireDate: [
          {
            required: true,
            message: "请选择生效日期",
            trigger: "blur"
          }
        ]
      },
      isLoad: false,
    };
  },
  created() {
    this.initTime();
    this.initTableInfo();
    this.getSysParamByTypes(["DISPLAY_CLIENT_TYPE"]);
    // 初始化表格数据->先获取已选中资源->调用资源列表接口
    this.getSelectResource();
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({types: types}).then((res) => {
        if (!res || res.code != 0) return;
        // res.data["DISPLAY_CLIENT_TYPE"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        this.displayTypeList = res.data["DISPLAY_CLIENT_TYPE"] || [];
      });
    },
    // 日期选择校验
    onDateChange(val) {
      if (val.length > 0) {
        let min = val[0];
        let max = val[1];
        if (moment(max).format("YYYY-MM-DD") < moment(new Date()).format("YYYY-MM-DD")) {
          this.ruleForm.expireDate = [];
          this.$message({
            message: "结束时间必须大于等于当前日期",
            type: "warning",
          });
        }
      }
    },
    initTime() {
      let date = new Date();
      let time = dateStringByFutureday(date, 7);
      this.ruleForm.expireDate = time;
    },
    // 初始化：多类型资源表格数据
    initTableInfo() {
      this.tableInfo = {
        originCheckList: [],
        data: [],
        total: 0,
        currentPage: 1,
        size: 10,
        currentCheckList: [],
      }
    },
    cancel() {
      this.$emit("closeManage");
    },
    handleSelectionChanges(rows) {
      let curTable = this.tableInfo;
      let union = curTable.currentCheckList.concat(rows);
      let result = [];
      let obj = {};
      // 去重
      for (var i = 0; i < union.length; i++) {
        if (!obj[union[i].bizId]) {
          result.push(union[i]);
          obj[union[i].bizId] = true;
        }
      }
      this.tableInfo.currentCheckList = result;
    },
    pageChange(page) {
      this.tableInfo.currentPage = page;
      this.getResources(this.$refs.search.filters);
    },
    sizeChange(size) {
      this.tableInfo.size = size;
      this.getResources(this.$refs.search.filters);
    },
    // 已添加资源
    getSelectResource() {
      haveResource({ configType: 2 }).then((res) => {
        if (res.code !== 0) return;
        for(let key in res.data) {
          this.tableInfo.originCheckList = res.data[key];
          // 初始选中列赋值
          this.tableInfo.currentCheckList = JSON.parse(JSON.stringify(res.data[key]));
        }
        this.getResources();
      })
    },
    // 历史选中回显置灰
    getResources(query={}) {
      this.isLoad = false;
      let params = {
        page: this.tableInfo.currentPage,
        limit: this.tableInfo.size,
        configType: 2, // 配置类型（1 新课上线消息 , 2 PC端首页课程)
        bizType: 1 // 公用接口，默认1
      };
      getResources({
        ...params,
        ...query,
      }).then((resp) => {
        if (resp.code !== 0) return;
        this.isLoad = true;
        // 资源分类 表格赋值
        this.tableInfo.data = resp.data.records;
        this.tableInfo.total = resp.data.total;
        this.tableInfo.currentPage = resp.data.current;
        let curTable = this.tableInfo;
        let nowPageIds = curTable.data.map((x) => x.bizId);
        let rows = [];
        let originCheckIdArr = curTable.currentCheckList.map(item => item.bizId);
        nowPageIds.forEach((x, i) => {
          if (Array.from(originCheckIdArr).includes(x)) {
            rows.push(curTable.data[i]);
          }
        });
        const _this = this;
        this.$nextTick(() => {
          rows.forEach((row) => {
            _this.$refs[`pageListTable`].$refs.table.toggleRowSelection(row, true);
          });
        });
      });
    },
    // 条件筛选
    searchHandle(data) {
      // 记住查询条件
      this.tableInfo.currentPage = 1;
      this.getResources(data);
    },
    confirm() {
      // 过滤出新选中数据
      let newCheckList = this.tableInfo.currentCheckList.filter(item => this.tableInfo.originCheckList.every(subItem => subItem.bizId !== item.bizId));
      let params = {
        configType: 2,  // 配置类型（1 新课上线消息 , 2 PC端首页课程)
        resourcesVos: newCheckList
      };
      if (newCheckList.length < 1) {
        this.$message({
          message: "请选择资源",
          type: "warning",
        });
        return;
      }
      if (this.ruleForm.expireDate && this.ruleForm.expireDate.length > 1) {
        params["expireStartDate"] = moment(this.ruleForm.expireDate[0]).format("YYYY-MM-DD");
        params["expireEndDate"] = moment(this.ruleForm.expireDate[1]).format("YYYY-MM-DD");
      }
      saveLeaderHomeConfig(params).then((res) => {
        if (!res || res.code != 0) return;
        this.$message({
          message: "添加成功",
          type: "success",
        });
        this.$emit("addSucceed");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .serach-form {
  border-bottom: none !important;
  margin-bottom: 0 !important;
}
.main-contant {
  min-height: 500px;
}
$text-color: #51627d;
$text-font: 14px;
@mixin text {
  color: $text-color;
  font-size: $text-font;
}
@mixin border {
  border: 1px solid #d7dbe0;
  border-radius: 2px;
}
@mixin panel {
  width: 48%;
  height: 300px;
  box-sizing: border-box;
  overflow: hidden;
}
.dialog {
  /deep/ .el-dialog__body {
    max-height: auto;
    .right-panel {
      float: right;
      @include border;
      @include panel;
    }
    .panel-header {
      background-color: #f2f3f4;
      height: 44px;
      display: flex;
      padding: 0 15px;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      & > span:first-child {
        @include text;
      }
    }
  }
}
</style>
